<template>
	<div class="ReListItem">
		<div class="taskBlock">
			<div class="col-2 taskTime">
				<div class="d-flex align-items-center">
					<p class="mr-1">{{isTaskTime(task)}}</p>
					<el-tooltip content="Комментарии к услуге" placement="top" >
						<button class="btn no-border btn-icon btn-fab btn-primary btn-simple" @click="getDopFieldsServices(task)"><i class="tim-icons icon-align-left-2 text-primary"></i></button>
					</el-tooltip>
				</div>
			</div>			
			<div class="col-md col-lg-4 pl-1 pr-0" >											
				<div class="taskName taskStatus" :class="[{'overdue':task.overdue == '1' && task.STATUS == 'Новая'}, {'current':task.overdue == '0' && task.STATUS=='Новая'}, {'success':task.STATUS == 'Готово'}]"> 
					<i></i>
					<div class="taskName-text"><router-link :to="'/data/tasks/id/'+task.id">{{task.BP_TASK_NAME}}</router-link></div>
				</div>
				
				<!-- <collapse >
					<collapse-item title="Комментарии к услуге"  @activate="getDopFieldsServices(task)" :activeIndex="activeDFS">
						<ul  v-if="masDopFieldsServices.length > 0">
							<li v-for="dopfield in masDopFieldsServices">{{dopfield.name}}: {{dopfield.val}}</li>
						</ul>
					</collapse-item>
				</collapse> -->
			</div>
			<!--div class="col-2 clientBlk"><p class="">{{task.fio}}</p></div-->
			<div class="col-2 clientBlk"><p class=""><router-link :to="'/data/clients/id/'+client_id+(client_phone!=''?'?phoneint='+client_phone:'')">{{task.fio}}</router-link></p></div>
			<div class="col-2 agentBlk"><p class="">{{task.service_agent}}</p></div>
			<div class="col-2 agentBlk"><p class="">{{task.agent_name}}</p></div>
			
			
		</div>
		<div >
			<div class="col" v-if="masDopFieldsServices.length > 0 && isShown">
				<p>Комментарии к услуге</p>
				<ul class="serviceTitle"  >
					<li v-for="dopfield in masDopFieldsServices" :key="dopfield.id" class="mr-3 ml-1 marker">{{dopfield.name}}: {{dopfield.val}}</li>
				</ul>				
			</div>
			<div class="col">
				<p v-if="!isShown && this.counter > 0 && masDopFieldsServices.length == 0">Комментарии не найдены</p>
			</div>
		</div>			
			
	</div>
</template>

<script>
import moment from 'moment';
// import VueMoment from 'vue-moment';
// import { Collapse, CollapseItem } from 'src/components';
import { Tooltip } from 'element-ui';

moment.locale('ru');

	export default {
		name: 'ReListItem',
		components: {
			// Collapse,
			// CollapseItem,
			[Tooltip.name]: Tooltip,	
			
		},
		props: {
			task: Object,
			bShowList:{
				type: Boolean,
				default: true
			},			
		},
		data () {
			return {
				ver: 1,
				masDopFieldsServices:[],
				activeDFS: -1,
				isHidden: false,
				isShown: false,
				counter: 0,
			}
		},
		computed: {
			client_id(){
				if(typeof this.task.client_id != 'undefined'){
					return this.task.client_id;
				}
				return -1;
			},
			client_phone(){
				if(typeof this.task.client_phone != 'undefined'){
					return this.task.client_phone.replace(/[^0-9]/g,"");
				}
				if(typeof this.task.client_phone_list != 'undefined'){
					return this.task.client_phone_list.replace(/[^0-9]/g,"");
				}
				return '';
			},
		},
		methods: {
			/*
			client_id(){
				if(typeof this.task.client_id != 'undefined'){
					return this.task.client_id;
				}
				return this.task.client_id;
			},*/
			OpenCard: function(client_id){
				this.$router.push({path: '/data/clients/id/'+client_id});
			},
			isTaskTime(task){
				if(typeof task != 'undefined'){
					return moment(task.STARTDATE).format('HH:mm');
				}	return false;
			},			
			getDopFieldsServices(task){		
				// this.masDopFieldsServices = [];		
				this.counter ++; //&& this.counter == 1
				if (task && this.counter == 1){
					// console.log(task.service_id);		

					this.$GVO.ApiCall('addons_fields.GET',{flt:{'obj_type':'services','obj_id':task.service_id}})
					.then((objApi) => {
						if(objApi.success === true) {
							for (let i = 0; i < objApi.data.length; i++) {
								const element = objApi.data[i];
								this.masDopFieldsServices.push({
									id: element.id,
									field_type: element.field_type,
									name: element.name,
									val: element.val,
									// elements: [{
									// 	elementGetParamMap: 'crud_input',
									// 	element_model: element.val,
									// 	elementType: 'input',
									// 	placeholder: 'Пиши в меня',
									// }]
								});
							}
							this.isShown = true;
						} 
						if(this.masDopFieldsServices.length == 0) {this.isShown = false;}
					}).catch(errorObjApi => console.error(errorObjApi));
				} else if (this.counter > 1 && this.masDopFieldsServices.length > 0){
					this.isShown = !this.isShown;
				}
				
			},
				
		},
		created() {
		
		}
	}
</script>
<style scoped>

.dateBlock, .taskBlock, .titleBlk {
	display: flex;
	width: 100%;
	padding: 7px 10px 7px 0;
	align-items: center;
}   
.dateBlock {
	background-color: #01B0E0;
}
.taskTime {padding-right: 0;}
.titleBlk h4 {margin-bottom: 10px;}
.taskHeader, .taskName {margin-left: 5px;}
.timeHeader, .taskTime {min-width: 80px;}
.dateBlockTxt {
	font-weight: 600;
	color: #fff;
	margin-bottom: 0;	
	font-size: 1rem;
}
.taskName {display: flex; align-items: baseline;}
.taskName a, .taskBlock p {margin-bottom: 0;}
.taskStatus > *{display: inline-block;}
.taskStatus i {
	width: 9px;
	height: 9px;
	border-radius: 50%;
	margin-right: 10px;
	background-color: #01B0E0;
}
.taskStatus.success i {background-color: #00BF9A;}
.taskStatus.current i {background-color: #01B0E0;}
.taskStatus.overdue i {background-color: #F84E54;}
.taskStatus.event i {background-color: #FF8D72;}
.taskName-text {
	display: flex;
	flex: 0 0 80%;
}

.ReListItem >>> .card-body {padding: 0;}
.ReListItem >>> .card-collapse .card:not(.card-cinc) .card-body {padding-left: 0; padding-right: 0;}
.ReListItem >>> .card-collapse .card:not(.card-cinc) .card-header a {color: #01B0E0 ;}

.ReListItem >>> .serviceTitle {list-style: none; padding-left: 0;}
.marker::before {
    content: "\20DD";
    color: #01B0E0;
    padding-right: 18px;
    font-size: 12px;
    font-weight: normal;
}

@media (max-width: 900px) {
	.clientHeader, .agentHeader, .clientBlk, .agentBlk {
		display: none;
	}
}
/*
@media (max-width: 400px) {
	.taskName p, .taskBlock p {max-width: 225px;}
}*/


</style>
